// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"LZ-z","sponsoredTooltipWrapper":"MZ-z","sponsoredTooltip":"NZ-z","newCard":"OZ-z"};